export const ENDPOINTS_PAIEMENT = {
  // Pas de CREATE_BILLING ni de SCHEDULE_* : ces routes acceptaient le statut
  // et le montant depuis le navigateur, et ouvraient donc un premium sans
  // paiement. Un abonnement s'ouvre chez un prestataire, et seul son webhook
  // l'active.
  GET_STATUS: (ids: number[]) => `/billing/status?user_ids=${ids.join(',')}`,
  // Les enfants du parent connecté, avec l'état de chaque abonnement.
  MES_ENFANTS: "/billing/mes-enfants",
  // Arrêt et reprise de la reconduction, PAR ENFANT. N'ouvrent aucun accès
  // et n'encaissent rien : elles disent au prestataire de cesser — ou de
  // reprendre — les prélèvements à venir. L'accès en cours n'est pas touché.
  ARRETER_RECONDUCTION: (id: number) => `/billing/abonnement/${id}/arreter`,
  REPRENDRE_RECONDUCTION: (id: number) => `/billing/abonnement/${id}/reprendre`,
  CASHPLUS: {
    INITIATE: "/billing/cashplus/initiate",
    CALLBACK: "/billing/cashplus/callback",
  },
  LEMONSQUEEZY: {
    INITIATE: "/billing/lemonsqueezy/initiate",
    WEBHOOK: "/billing/lemonsqueezy/webhook",
  },
  PRICING: {
    LIST: "/pricing",
    UPSERT: "/pricing",
    DELETE: (id: number) => `/pricing/${id}`,
  },
  // Canal écoles. Le code ne sert qu'à appliquer le tarif négocié : il n'ouvre
  // aucun accès, seul un paiement confirmé le fait.
  ECOLE: {
    REGLEMENT: "/billing/ecole/reglement",
    VERIFIER_CODE: (code: string) =>
      `/billing/ecole/code/${encodeURIComponent(code)}`,
    ELEVES_SELECTIONNABLES: (orgID: number) =>
      `/billing/ecole/${orgID}/eleves-selectionnables`,
    SIGNALEMENTS: "/billing/ecole/signalements",
  },
  // Canal apporteurs : l'espace de l'animateur connecté (son animateur est
  // celui de la SESSION, jamais un paramètre) et l'administration.
  APPORTEURS: {
    MOI: "/apporteurs/moi",
    ADMIN: "/apporteurs/admin",
    ADMIN_UN: (id: number) => `/apporteurs/admin/${id}`,
    ADMIN_PARRAINAGE: (id: number) => `/apporteurs/admin/${id}/parrainage`,
    // Publique : la vérification d'un code ne nomme jamais l'animateur.
    VERIFIER_CODE: (code: string) => `/apporteurs/code/${encodeURIComponent(code)}`,
    MON_MOIS: (mois?: string) => `/apporteurs/moi/mois${mois ? `?mois=${encodeURIComponent(mois)}` : ''}`,
    TABLEAU: (de?: string, a?: string) => {
      const p = new URLSearchParams();
      if (de) p.set('de', de);
      if (a) p.set('a', a);
      const q = p.toString();
      return `/apporteurs/admin/tableau${q ? `?${q}` : ''}`;
    },
    ADMIN_MOIS: (id: number, mois: string) => `/apporteurs/admin/${id}/mois?mois=${encodeURIComponent(mois)}`,
    ECOLES: "/apporteurs/admin/ecoles",
    ORGANISATIONS: (q: string) => `/apporteurs/admin/organisations?q=${encodeURIComponent(q)}`,
    ASSOCIER_ECOLE: (id: number) => `/apporteurs/admin/${id}/ecoles`,
    DISSOCIER_ECOLE: (associationId: number) => `/apporteurs/admin/ecoles/${associationId}/dissocier`,
    ENFANT: (id: number) => `/apporteurs/admin/enfants/${id}`,
    CORRECTIONS: "/apporteurs/admin/corrections",
  },
  // B2B : contrats écoles, prix négociés, seuils et abonnements.
  B2B: {
    OFFRES: "/pricing/b2b/offres",
    ORGANISATIONS: "/pricing/b2b/organisations",
    ECOLES: "/pricing/b2b/ecoles",
    ECOLE: (id: number) => `/pricing/b2b/ecoles/${id}`,
    ABONNEMENTS_ECOLE: (orgID: number) => `/pricing/b2b/ecoles/${orgID}/abonnements`,
    ABONNEMENTS: "/pricing/b2b/abonnements",
    SIGNALEMENTS: (orgID: number) => `/pricing/b2b/ecoles/${orgID}/signalements`,
    TRAITER_SIGNALEMENT: (id: number) => `/pricing/b2b/signalements/${id}/traiter`,
    SYNC: "/billing/ecole/sync",
  },
};
